import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";
export const env = createEnv({
    shared: {
        NODE_ENV: z.enum(["development", "production", "test"]).optional(),
    },
    runtimeEnv: {
        NODE_ENV: process.env.NODE_ENV,
    },
});
